// extracted by mini-css-extract-plugin
var _1 = "MqTnNSaV";
var _2 = "K53pM06o";
var _3 = "Wi0UCZzC";
var _4 = "K53pM06o";
var _5 = "Wi0UCZzC";
var _6 = "g08s2NPR";
var _7 = "qZiA1gkc";
var _8 = "SstETDah";
export { _1 as "dialog", _2 as "dialog-close", _3 as "dialog-content", _4 as "dialogClose", _5 as "dialogContent", _6 as "large", _7 as "medium", _8 as "small" }
